/**
 * 这里维护CMS中，产品的code，根据这些code获取对应的文档列表
 */

// NOTE: 判断是不是线上数据库，部分产品code 线上和测试环境没对齐，比如直播云
const env = process.env.NEXT_PUBLIC_NODE_ENV;
const isProdDB = ['pre', 'production'].includes(env);

export const productCodeMap = {
  VOD: 'VOD', // 点播云
  LIVE: isProdDB ? 'PRD8' : 'LIVE', // 直播云 线上PRD8 测试环境LIVE
  MPS: 'MPS', // 媒体处理
  MEDIA_SDK: 'MEDIASDK', // 音视频SDK
  ON_VIDEO: 'PRD2', // 快手云剪
  JIMU: 'PRD3', // 极目
  INTELLG_VFX: 'INTELLG-VFX', // 智能特效
  FACE_BUTI: 'FACE-BUTI', // 人像美化
  AI_CREATION: 'PRD7', // 智能创作
  BIG_SCREEN: 'PRD6', // 智能大屏
  INTELLG_TAG: isProdDB ? 'INTELLG-TAG' : 'TAGS', // 智能标签
  INTELLG_AUDIT: isProdDB ? 'INTELLG-AUDIT' : 'AUDIT', // 智能审核
  QUALITY_ANALYSIS: 'PRD5', // 质量分析
  ORIGINALITY_PROTECTION: 'PRD4', // 原创保护
  VTM: 'VTM', // 虚拟人
  // SIX_DOF: '' // 六自由度
};

export const productCodes = Object.values(productCodeMap);
